import React, {useState} from 'react';
import { Flex, Form, Input } from "antd";
import styles from "./Phone.module.scss";
// @ts-ignore
import { ReactComponent as LogoIcon } from '../../../../assets/images/logo/logo.svg'
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import CustomButton from "../../../../components/UI/CustomButton/CustomButton";
import {useNavigate} from "react-router";
import {useVerifyPhoneMutation} from "../../../../redux/API/userSlice";
import useCreateBusinessForm from "../../../../hooks/useCreateBusinessForm";

const BusinessPhone = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const savedForm = useSelector((state: RootState) => state.business);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [verifyPhone] = useVerifyPhoneMutation()

  const { form, handlePhoneChange, isDisabledPhoneBtn, onFinish, values } = useCreateBusinessForm();

  const handleSubmit = async () => {
    try {
      setErrorMessage(null);

      await onFinish();
      await verifyPhone({
        body: {
          countryCode: '1',
          phone: values?.phone.replace(/\D/g, ""),
        },
        accessToken: savedForm.accessToken
      }).unwrap();

      navigate('../business/phone-verify');
    } catch (error) {
      const err = error as { data?: { message?: string } };
      setErrorMessage(err.data?.message || t('somethingWentWrong'));
    }
  };

  return (
    <Flex className={styles.Phone__wrapper} justify={"center"} align={"center"}>
      <Flex className={styles.Phone} vertical justify={"center"} align={"center"}>
        <Flex className={styles.Phone__header} vertical justify={"center"} align={"center"} gap={'32px'}>
          <LogoIcon />
          <Flex vertical gap={'16px'}>
            <h1>Create New Account</h1>
            <p>Enter your phone number to verify it</p>
          </Flex>
        </Flex>
        <Form
          className={styles.Phone__form}
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Form.Item
            name="phone"
            label={'Phone Number'}
            rules={[{ min: 14, message: t('invalidPhone') }]}
            help={errorMessage}
          >
            <Input
              type="text"
              maxLength={14}
              onChange={handlePhoneChange}
              className={styles.Phone__form__input}
              prefix="+1 "
            />
          </Form.Item>

          <Form.Item>
            <Flex className={styles.Phone__form__button}>
              <CustomButton text={'Next'} disable={isDisabledPhoneBtn} htmlType="submit"/>
            </Flex>
          </Form.Item>
        </Form>
      </Flex>
    </Flex>
  );
};

export default BusinessPhone;
